import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cardNumEnd',
  standalone: true
})
export class CardNumEndPipe implements PipeTransform {

  transform(lastFour: number | string): string {
    lastFour = String(lastFour);
    if (lastFour.length === 1) return `000${lastFour}`;
    else if (lastFour.length === 2) return `00${lastFour}`;
    else if (lastFour.length === 3) return `0${lastFour}`;
    else return `${lastFour}`;
  }

}
